import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalContext";
import SearchByCompany from "./searchBySubComponents/SearchByCompany";
import SearchByKeyword from "./searchBySubComponents/SearchByKeyword";
import Categories from "./CategoryComponents/Categories";
import { ClientContext } from "../context/Client/ClientContext";

const SearchBy = () => {
  const {
    showCompanyInput,
    showKeywordInput,
    showCategoryInput,
    showCompanySearch,
    showKeywordSearch,
    showCategorySearch,
    showSearchBy,
    toggleLimitButtons,
    toggleLimitSearch,
    resetSearchByBtnState,
    toggleShowCompanyInput,
    toggleShowKeywordInput,
    toggleShowCategoryInput,
    toggleShowKeywordSearch,
    toggleShowCategorySearch,
    toggleShowCompanySearch,
  } = useContext(GlobalContext);

  const {
    hideClientList,
    clearCategorySearch,
    clearSelectedClient,
    clearClassSubClassClient,
    clearCompanyNameSearch,
  } = useContext(ClientContext);

  const commonActions = () => {
    toggleLimitButtons();
    toggleLimitSearch();
    hideClientList();
    clearSelectedClient();
    clearClassSubClassClient();
  };

  const handleCompany = () => {
    commonActions();
    toggleShowCompanyInput();
    toggleShowKeywordSearch();
    toggleShowCategorySearch();
    clearCategorySearch();
    clearCompanyNameSearch();
  };

  const handleKeyword = () => {
    commonActions();
    toggleShowKeywordInput();
    toggleShowCompanySearch();
    toggleShowCategorySearch();
  };

  const handleCategory = () => {
    commonActions();
    toggleShowKeywordSearch();
    toggleShowCompanySearch();
    toggleShowCategoryInput();
  };

  if (!showSearchBy) return null;

  return (
    <div className="gog-search-by">
      <div className="gog-search-by-title">
        <span>Search Method</span>
        <h3>Search By</h3>
        <p>Choose how you want to find merchants in the directory.</p>
      </div>

      <div className="gog-search-method-grid">
        {showCompanySearch && (
          <div className="gog-search-method-card">
            <div>
              <strong>Company</strong>
              <span>Search directly by business or company name.</span>
            </div>

            <button
              type="button"
              onClick={handleCompany}
              className="gog-secondary-btn"
            >
              Company
            </button>

            {showCompanyInput && (
              <div className="gog-search-inner-panel">
                <SearchByCompany resetSearchByBtnState={resetSearchByBtnState} />
              </div>
            )}
          </div>
        )}

        {showKeywordSearch && (
          <div className="gog-search-method-card">
            <div>
              <strong>Keyword</strong>
              <span>Find businesses using services, products, or terms.</span>
            </div>

            <button
              type="button"
              onClick={handleKeyword}
              className="gog-secondary-btn"
            >
              Keyword
            </button>

            {showKeywordInput && (
              <div className="gog-search-inner-panel">
                <SearchByKeyword resetSearchByBtnState={resetSearchByBtnState} />
              </div>
            )}
          </div>
        )}

        {showCategorySearch && (
          <div className="gog-search-method-card">
            <div>
              <strong>Category</strong>
              <span>Browse merchants by category, class, and attributes.</span>
            </div>

            <button
              type="button"
              onClick={handleCategory}
              className="gog-secondary-btn"
            >
              Category
            </button>

            {showCategoryInput && (
              <div className="gog-search-inner-panel">
                <Categories />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBy;